import React from 'react';
import { ButtonLink } from '../link/button-link';

type Props = {
	title: string;
	linkHref?: string;
	linkTitle?: string;
	children?: React.ReactNode;
};

export const PageTitle: React.FC<Props> = ({ title, linkHref, linkTitle, children }) => (
	<div className="mb-4">
		<div className="flex justify-between flex-col md:flex-row">
			<h1 className="text-white md:text-left text-center">{title}</h1>
			{(!!linkHref && !!linkTitle) && (
				<ButtonLink href={linkHref} className="self-center" title={linkTitle} />
			)}
		</div>
		{!!children && (
			<p className="text-white font-light">
				{children}
			</p>
		)}
	</div>
);
